import * as T from './AddPet.types';
import transport from '@media-ui/core/src/tools/transport';
export const filterData = (data: Record<string, any>, predicate: (item: any) => boolean) => Object.keys(data)
    .filter((key: string) => predicate(data[key]))
    .reduce((res: Record<string, string>, key: string) => {
    res[key] = data[key] === true ? 'on' : data[key];
    return res;
}, {} as Record<string, string>);
export const getDefaultValuesFromRemote = (remote: T.IAddPetContext['remote'] | undefined) => {
    if (!remote)
        return remote;
    return (Object.keys(remote.form.fields) as Array<keyof typeof remote.form.fields>).reduce((acc, item) => {
        acc[item] = remote.form.fields[item].value;
        return acc;
    }, {} as Record<string, string>);
};
export const sendDataToServer = (url: string, data: any) => {
    const filteredData = filterData(data, (item) => item !== null && item !== false);
    const formDataObject = new FormData();
    Object.entries(filteredData).forEach(([key, value]) => {
        formDataObject.append(key, value);
    });
    return transport(url, {
        method: 'POST',
        body: formDataObject,
    });
};
export const getStatBannerId = (): string | null => {
    const urlObject = new URL(window.location.href);
    const urlQueryParams = urlObject.searchParams;
    return urlQueryParams.get('rb_purina');
};
